export interface TimeRemaining {
  days: number
  hours: number
  minutes: number
  seconds: number
  total: number
}

export function calculateTimeRemaining(targetDate: string): TimeRemaining {
  const total = new Date(targetDate).getTime() - Date.now()

  if (total <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 }
  }

  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))

  return { days, hours, minutes, seconds, total }
}

export function formatCountdown(time: TimeRemaining): string {
  if (time.total <= 0) return 'Closed'

  if (time.days > 0) {
    return `${time.days}d ${time.hours}h ${time.minutes}m`
  }
  if (time.hours > 0) {
    return `${time.hours}h ${time.minutes}m`
  }
  return `${time.minutes}m ${time.seconds}s`
}
